import { liebowitzQuestions } from '../data/forms';

export const calculateLiebowitz = (answers) => {
  let totalScore = 0;
  let risks = [];

  Object.entries(answers).forEach(([questionId, score]) => {
    const numId = Number(questionId);
    const numericScore = Number(score); // 0, 1, 2 veya 3

    totalScore += numericScore;

    // KLİNİK MÜDAHALE: 2 (Oldukça) ve 3 (Çok Fazla) diyenleri riskli durumlara ekliyoruz
    if (numericScore >= 2) {
      // Soru metnini veritabanından çekiyoruz
      const question = liebowitzQuestions.find(q => q.id === numId);
      const actualText = question ? question.text : `Soru ${questionId}`;

      risks.push({
        id: numId,
        text: actualText,
        score: numericScore,
        isCritical: numericScore === 3 // 3 (Çok Fazla) diyenler kırmızı / kritik alarm
      });
    }
  });

  // Klinik Değerlendirme Çıktısı (Min: 0, Maks: 72)
  let summaryText = "Normal (Klinik Düzeyde Kaygı Yok)";
  if (totalScore >= 60) {
    summaryText = "Şiddetli Sosyal Fobi (Kırmızı Alarm)";
  } else if (totalScore >= 45) {
    summaryText = "Belirgin Sosyal Kaygı (Riskli)";
  } else if (totalScore >= 30) {
    summaryText = "Orta Düzey Sosyal Kaygı";
  }

 // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  let masterRisk = "low";
  if (totalScore >= 60) masterRisk = "high";
  else if (totalScore >= 45) masterRisk = "medium";

  // Evrensel sıralama için 72 üzerinden alınan puanı 100'lük yüzdelik sisteme çeviriyoruz
  const riskScore = Math.round((totalScore / 72) * 100);

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore, // 100 üzerinden eşdeğer risk puanı
    masterRisk: masterRisk,
    isCritical: false, // Sosyal fobi ciddidir (high) ama anlık kriz (critical) değildir
    domain: "psychological", // Psikolojik alan

    // 2. Mevcut Detaylı Veriler (Dashboard ve Raporlar için dokunmadık)
    totalScore, 
    risks, 
    summary: summaryText,
    riskLevel: masterRisk // Geriye dönük uyumluluk
  };
};